import ServiceWorkerAutomobile from './service-worker.js';
const pluginName = 'serviceworkerautomobile';

export default {
    init() {
        $.fn[pluginName] = function() {
            let sw = new ServiceWorkerAutomobile();
            sw.init();
        };

        $(document)[pluginName]();
    }
};
